module.exports = __webpack_public_path__ + "img/head-side-mask.506b8914.svg";